'use client'

import { withStyles } from '@bruitt/classnames'
import { FC } from 'react'

import { Container } from '@uikit/container'
import { SvgNextArrow } from '@/uikit/svg'
import { Button } from '@/uikit/button'

import styles from './breadcrumbs.module.scss'

interface BreadcrumbsProps {
  links: { text?: string; link?: string; isLoading?: boolean }[]
  size?: 'small' | 'default'
}

const sx = withStyles(styles)

export const Breadcrumbs: FC<BreadcrumbsProps> = ({ links, size = 'default' }) => {
  return (
    <Container>
      <div
        className={sx('breadcrumbs', { size })}
        itemScope
        itemType="https://schema.org/BreadcrumbList"
      >
        {links.map(({ text, link }, index) =>
          links.length === index + 1 ? (
            <div
              key={text}
              itemProp="itemListElement"
              itemScope
              itemType="https://schema.org/ListItem"
            >
              <Button
                variant="neutral"
                className={styles.text}
                itemProp="item"
                href={link}
                disabled
              >
                <span itemProp="name">{text}</span>
                <meta itemProp="position" content={`${index + 1}`} />
              </Button>
            </div>
          ) : (
            <div key={link}>
              {link && text && (
                <div itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem">
                  <Button variant="neutral" itemProp="item" href={link} className={styles.link}>
                    <span itemProp="name">{text}</span>
                    <SvgNextArrow />
                    <meta itemProp="position" content={`${index + 1}`} />
                  </Button>
                </div>
              )}
            </div>
          ),
        )}
      </div>
    </Container>
  )
}
